"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryCreditPeriod = exports.arbitraryCreditAmount = void 0;
const tslib_1 = require("tslib");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
const credit_1 = require("../../src/credit");
exports.arbitraryCreditAmount = fast_check_1.default
    .integer({ min: 0, max: 20 })
    .map((value) => credit_1.CreditAmount.parse(value));
exports.arbitraryCreditPeriod = fast_check_1.default
    .date({
    min: new Date("2024-01-01T00:00:00.000Z"),
    max: new Date(),
})
    .map((date) => (0, credit_1.currentCreditPeriod)("flux", date));
//# sourceMappingURL=credit.js.map